module.exports = require('../../module.compiled').vendored[
  'react-ssr'
].ReactServerDOMWebpackClientEdge
